import React from 'react';

const cross = (
  <div className="cross">
    <i className="sa sa-times" />
  </div>
);

function FailureOverlay({ content = cross, background = 'rgba(255,255,255, 1)' }) {
  return (
    <div
      className="success-confirmation-overlay"
      style={{ background }}
    >
      {content} <span className="u-padding-left-small">Sorry something went wrong.</span>
    </div>
  );
}


export default FailureOverlay;



// WEBPACK FOOTER //
// ./src/parts/FailureOverlay.js